import React, { useEffect, useState, useRef } from 'react';
import Menu from '../../components/Menu';
import api from '../../services/api';
import { useParams } from 'react-router-dom';



function Faturas(props){
    const { id } = useParams();
    const [copiado, setCopiado] = useState(false);
//    console.log(props)
const [statusPg, setStatusPg] = useState('');
const [msgError, setMsgError] = useState('');
    const inputRef = useRef(null);
    const [carregado, setCarregado] = useState(false);
    const [Pago, setPago] = useState(false);
    const [copiaeCola, setCopiaeCola] = useState('');
    const [cpf, setCpf] = useState('');
    const [nome, setNome] = useState('');
    const [periodo, setPeriodo] = useState('');
    const [qrCode, setQrCode] = useState('');
    const [valor, setValor] = useState('');
    const [idPagamento, setIdPagamento] = useState('');
    const [usuario, setUsuario] = useState('');
    // const [cpf, setCpf] = useState('');
    const [senha, setSenha] = useState('');
    const [plano, setPlano] = useState('');
    const [repitaSenha, setRepitaSenha] = useState('');
    const [msg, setMsg] = useState('');
    const [btnLogarSe, setBntLogueSe] = useState(false);
    const handleCadastrar = async() => {
        setMsg('');
        var res = await api.post('/Cadastre-se', {cpf, nome, usuario, plano, senha, repitaSenha});
        console.log(res.data);
        if(typeof res.data.msg != 'undefined') {
            if(res.data.msg.indexOf('logue-se para continua') != -1) {
                setBntLogueSe(true);
                setMsg(res.data.msg);
            } else{
                setBntLogueSe(false);
            }
        }
    };

    useEffect(() => {
        const getDadosPagar = async() => {
            setMsg('');
            var res = await api.get('/fatura/' + id);
           // console.log(res.data);
           console.log(typeof res.data.error);
            if(typeof res.data.error != 'undefined') {
                setMsgError('ERROR: '+res.data.error);
                
            } else if(typeof res.data.msg != 'undefined') {
              
                
                if(res.data.msg.indexOf('logue-se para continua') != -1) {
                    setBntLogueSe(true);
                    setMsg(res.data.msg);
                } else{
//                    setStatusPg('Aguardando pagamento');
                    
                        setMsg(res.data.msg);
                    
//                    setPago(true);
                }
            }

            setCpf(res.data.cpf);
            setNome(res.data.nome);
            setValor(res.data.valor);
            setPeriodo(res.data.periodo);
            setCopiaeCola(res.data.copiaecola);
            setQrCode(res.data.qrcode);
            setIdPagamento(res.data.idpagamento);

            setCarregado(true);
        };
        getDadosPagar();
    }, [id]);


    useEffect(() => {
        const fetchData = async () => {
          try {
            var response = await api.get('/checkPix/' + idPagamento);
            if(response.data.status == 'pago') {
                setMsg('Pagamento realizado com sucesso  ');
                setPago(true);
                setBntLogueSe(true);
                setTimeout(() => {
                    window.location.href = '../../../Painel';
                    return;
                }, 10000);
            } else{
                setMsg('');
                setPago(false);
                setBntLogueSe(false);
            }
//            console.log(response.data);
//            const response = await axios.get('sua-url-aqui');
//            setData(response.data);
          } catch (error) {
            console.error('Erro ao buscar os dados:', error);
          }
        };
    
        // Chamada inicial
        fetchData();
    
        // Atualização a cada 15 segundos
        const interval = setInterval(fetchData, 15000);
    
        // Limpeza do intervalo quando o componente é desmontado
        return () => clearInterval(interval);
      }, [idPagamento]); // Passando um array vazio para garantir que useEffect só seja executado uma vez

      
      
    const Voltar = (e) => {
        e.preventDefault(0);
        window.location = './Painel';
        return;
    }

      
        const handleCopy = () => {
          // Seleciona o conteúdo do input
          inputRef.current.select();
      
          // Copia o conteúdo para a área de transferência
          document.execCommand('copy');
          setCopiado(true);
          setTimeout(() => {
            setCopiado(false);
          }, 9000);
        };

    return (<div class="main-content" style={{marginLeft: '0'}}>
    <div id="page-wrapper">
        <div class="container">
            <div class="row">
                <div class="col-md-4 col-md-offset-4" style={{marginTop: '100px'}}>
                    <img src={'../../../public/assets/logoupbusca.png'} alt="Up Busca" class="center-block img-responsive" id="logo" style={{marginTop: '-10%'}}/>
                </div>
            </div>
        </div>
    <div>

      <div class="row">
          <div class="col-md-10 col-md-offset-1">
            <ul class="nav nav-tabs" role="tablist" style={{marginTop: '0px'}}>
                <li role="presentation" class="active">
                    <a href="#home" aria-controls="home" role="tab" data-toggle="tab" class="tab-result">PAGAR FATURA</a>
                </li>
            </ul>

            <div class="tab-content">
                <div role="tabpanel" class="tab-pane active" id="home">
                    <div class="table-responsive" style={{marginTop: '12px'}}>
                    {carregado == true ? (
                    <div class="row">
			
                        <div>
                            
                        <div class="form-group col-md-12" style={msgError.length > 1 ? {display: 'none',marginTop: '10px'} : {display: 'block',marginTop: '10px'}}>
                        {Pago == false ? (
                            <>
                        <div className='row' style={{display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', fontWeight: 'bold'}}>
                        <p>Pague com PIX</p>
                        
                        <p style={{fontWeight: 'normal'}}>Quando o pagamento for aprovado, o valor será creditado de forma instantânea.</p>
                        </div>
                        <center>
                            <div style={{display: 'flex', flexDirection: 'row', alignContent: 'center', justifyContent: 'center', alignItems: 'center'}}>
                                <p style={{width: '185px'}}>Pix Code</p>
                                <div style={{width: '2px', height: '30px', background: '#f0f0f0'}}></div>
                                <p style={{width: '185px'}}>R$ {valor}</p>
                            </div>
                                    <img src={qrCode} width={250}/>
                                </center></>) : (``)}
                            </div>

                        <div class="form-group col-md-12" style={msgError.length > 1 ? {display: 'none'} : {display: 'block'}}>
                        {Pago == false ? (
                            <>
                            {/* <span>PIX COPIAR E COLAR:</span> */}
                                <input type="text" ref={inputRef} class="form-control" id="copiaecola" name="copiaecola" value={copiaeCola}/>
                               <center>
                                <br/>
                                <button id="btAtualizarSenha" onClick={handleCopy} type="button" class="btn btn-primary">COPIAR CÓDIGO DE QR CODE</button>
                                <button style={{marginLeft: '10px', background: 'black', color: '#fff'}} id="btnVoltar" onClick={() => window.location.href="../../../../Perfil"} type="button" class="btn btn-dark">Voltar</button>
                                </center>    
                                {copiado ? (<div className="alert alert-success" style={{marginTop: '20px'}}>
                                <i className="fa fa-check" style={{marginRight: '5px'}}></i>
                                Copiado com sucesso!</div>) : (``)}
                            </>
                        ) : (<></>)}

<div className='row' style={{marginTop: '20px'}}>
<div class="table-responsive">
                    <table id="mytable" class="table table-bordred table-striped">
                    <thead>
                            <tr>
                                <td>Pagador</td>
                                <td>Valor a pagar</td>
                                <td>Periodo</td>
                                <td>ID Pagamento</td>
                                <td>Status</td>
                            </tr>
                        </thead>
                        <tbody>
                        
                      <tr>
                        <td>
                            {nome}
                        </td>
                        <td>
                            R$ {valor}
                        </td>
                        <td>
                            {periodo} Dias
                        </td>
                        <td>
                            {idPagamento}
                        </td>
                        <td>
                        {Pago == true ? <span style={{color: 'green', fontWeight: '600'}}>PAGO</span> : <span style={{color: 'orange', fontWeight: '600'}}>PENDENTE</span>}
                        </td>
                      </tr>
                       
                        
                        </tbody>
                        
                    </table>
                </div>
                </div>

                        
                       
                        </div>

                            <div className='form-groud col-md-12'>
                                <p style={{fontWeight: 'bold', textAlign: 'center'}}>
                                    {msg ?? ''}
                                    {msgError ? (
                                        <>
                                        {msgError}
                                        <br/>
                                        <a href="../../Perfil">Voltar</a>
                                        </>) : ``}
                                    {btnLogarSe == true ? <a href="../../Painel">Clique aqui!</a> : ''}
                                </p>
                            </div>
                           

                        </div>
                        <br/>
                    
                    </div>) : <div><br/>
                    <div className="alert alert-warning" role="alert" style={{marginLeft: '5%', marginRight: '5%'}}>
                        Aguarde, carregando...
                    </div>
                    <br/><br/></div>}
                    <br/>
                    </div>
                </div>
            </div>
        </div>
    </div>

  
</div>

</div></div>);
}

export default Faturas;
